import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { LeadService } from '../services/leads/lead.service';

@Injectable({
  providedIn: 'root',
})
export class SelectedLeadsGuard implements CanActivate {
  constructor(
    private readonly leadService: LeadService,
    private readonly router: Router,
  ) {}

  canActivate(): boolean {
    if (this.leadService.hasSelectedLeads()) {
      return true;
    }

    // Redirect to lead-pool if no leads are selected
    this.router.navigate(['/lead-pool']);
    return false;
  }
}
